import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, TextField } from '../../../components';
import { useStore } from '../../../store';
import CenteredForm from '../components/CenteredForm';
import LoginLayout from '../components/LoginLayout';
import PasswordField from './components/PasswordField';
import classes from './LoginPage.module.scss';

export default observer(function LoginContainer() {
  const { authStore } = useStore();
  const [signingIn] = useState(() => authStore.createSigningIn());
  const navigate = useNavigate();

  async function onLogin() {
    if (await signingIn.signIn()) {
      navigate('/', { replace: true });
    }
  }

  return (
    <LoginLayout>
      <CenteredForm onSubmit={onLogin}>
        <TextField
          autoFocus
          errorText={signingIn.errors.email}
          InputProps={{ autoComplete: 'username' }}
          label="Email"
          name="email"
          onBlur={signingIn.handleBlur}
          onChange={signingIn.handleChange}
          value={signingIn.email}
        />

        <PasswordField
          errorText={signingIn.errors.password}
          helperText={
            <Link className={classes.resetLink} to="/login/reset">
              Reset password
            </Link>
          }
          InputProps={{ autoComplete: 'current-password' }}
          label="Password"
          name="password"
          onBlur={signingIn.handleBlur}
          onChange={signingIn.handleChange}
          value={signingIn.password}
        />

        {Boolean(signingIn.errors.response) && (
          <div className={classes.error}>{signingIn.errors.response}</div>
        )}

        <Button className={classes.loginButton} onClick={onLogin} type="submit">
          Log in
        </Button>
      </CenteredForm>
    </LoginLayout>
  );
});
